import { render, staticRenderFns } from "./LoginRider.vue?vue&type=template&id=2977890d&scoped=true"
import script from "./LoginRider.vue?vue&type=script&lang=js"
export * from "./LoginRider.vue?vue&type=script&lang=js"
import style0 from "./LoginRider.vue?vue&type=style&index=0&id=2977890d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2977890d",
  null
  
)

export default component.exports